export default "/images/framework/MyPuzzleEng.b2cef785.svg?b2cef785";